module.exports = "//static.hsappstatic.net/LoginUI/static-1.8261/img/ms-logo.png"